import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '@phase2/outline-core';
import {
  customElement,
  property,
  queryAssignedElements,
} from 'lit/decorators.js';
import componentStyles from './pc-search-teaser.css.lit';
import { MobileController } from '@phase2/outline-core';
import globalStyles from './pc-search-teaser.lightDom.css.lit';
import { AdoptedStyleSheets } from '@phase2/outline-adopted-stylesheets-controller';

import '../pc-heading/pc-heading';
import '../pc-wysiwyg/pc-wysiwyg';
import '../pc-image/pc-image';
/**
 * The PcSearchTeaser component
 * @element pc-search-teaser
 * @slot type - expecting span with content type
 * @slot subtype - option slot for span
 * @slot main - for heading and content wysiwyg text
 * @slot image - optional image slot.
 */
@customElement('pc-search-teaser')
export class PcSearchTeaser extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  adoptedStylesheets: AdoptedStyleSheets;
  private mobileController = new MobileController(this);

  /**
   * Ref to subtype slot
   */
  @queryAssignedElements({ slot: 'subtype' })
  subtypeRef: Array<HTMLElement>;

  /**
   * If mobile
   */
  @property({ type: Boolean, reflect: true })
  isMobile: boolean;

  @property({ type: Boolean, reflect: false })
  hasSubtype: boolean;

  connectedCallback() {
    super.connectedCallback();
    this.adoptedStylesheets = new AdoptedStyleSheets(globalStyles);
    this.addController(this.adoptedStylesheets);
  }

  firstUpdated() {
    this.hasSubtype = !!this.subtypeRef.length;
  }

  render(): TemplateResult {
    this.isMobile = this.mobileController.isMobile;

    return html`
      <section class="pc-search-teaser">
        ${!this.isMobile ? this.desktopTemplate() : this.mobileTemplate()}
      </section>
    `;
  }

  desktopTemplate() {
    return html` <div class="pc-search-teaser--desktop-wrapper">
      <div class="pc-search-teaser--desktop-type">
        <slot name="type"></slot>
        <slot name="subtype"></slot>
      </div>
      <div class="pc-search-teaser--desktop-main">
        <slot name="main"></slot>
      </div>
      <div class="pc-search-teaser--desktop-image">
        <slot name="image"></slot>
      </div>
    </div>`;
  }

  mobileTemplate() {
    return html`
      <div class="pc-search-teaser--mobile-wrapper">
        <div class="pc-search-teaser--mobile-type">
          <slot name="type"></slot>
          ${this.hasSubtype ? html`<pc-rectangle></pc-rectangle>` : null}
          <slot name="subtype"></slot>
        </div>
        <div class="pc-search-teaser--mobile-image">
          <slot name="image"></slot>
        </div>
        <div class="pc-search-teaser--mobile-main">
          <slot name="main"></slot>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-search-teaser': PcSearchTeaser;
  }
}
